module.exports = __webpack_public_path__ + "static/media/team-6.315c23fa.png";